import { Link } from 'react-router-dom';

export const AvisoLegal = () => (
  <div className="min-h-screen bg-[#0A0A0A] text-white">
    <div className="max-w-3xl mx-auto px-6 py-24">
      <Link to="/" className="font-mono text-[11px] tracking-widest uppercase text-gold hover:text-white transition-colors mb-12 inline-block">
        ← Volver
      </Link>
      <h1 className="font-display text-4xl font-light mb-12">Aviso Legal</h1>

      <div className="space-y-10 font-sans text-sm text-white/70 leading-relaxed">

        <section>
          <h2 className="text-white font-medium mb-3">1. Datos identificativos</h2>
          <p>En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSICE), se informa:</p>
          <ul className="mt-3 space-y-1 list-none">
            <li><strong className="text-white/90">Titular:</strong> L&C Digital & Consulting, S.L.</li>
            <li><strong className="text-white/90">NIF:</strong> B22652069</li>
            <li><strong className="text-white/90">Domicilio social:</strong> Calle del Poeta Joan Maragall 23, 28020 Madrid, España</li>
            <li><strong className="text-white/90">Registro Mercantil:</strong> Registro Mercantil de Madrid, Hoja M-859195, Inscripción 1ª</li>
            <li><strong className="text-white/90">EUID:</strong> ES28065.082379878</li>
            <li><strong className="text-white/90">Correo electrónico:</strong> legal@lycconsulting.com</li>
            <li><strong className="text-white/90">Nombre comercial:</strong> Wingfold</li>
          </ul>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">2. Objeto y ámbito de aplicación</h2>
          <p>El presente Aviso Legal regula el acceso y uso del sitio web <strong className="text-white/90">wingfold.es</strong> (en adelante, "el Sitio"), titularidad de L&C Digital & Consulting, S.L., que opera bajo el nombre comercial Wingfold para la prestación de servicios de performance marketing y publicidad digital.</p>
          <p className="mt-2">El acceso al Sitio implica la aceptación plena y sin reservas de las presentes condiciones.</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">3. Propiedad intelectual e industrial</h2>
          <p>Todos los contenidos del Sitio (textos, imágenes, logotipos, diseño, código fuente) son propiedad de L&C Digital & Consulting, S.L. o dispone de las licencias correspondientes. Queda prohibida su reproducción, distribución o comunicación pública sin autorización expresa.</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">4. Exclusión de responsabilidad</h2>
          <p>L&C Digital & Consulting, S.L. no garantiza la disponibilidad continua del Sitio ni se responsabiliza de los daños derivados de interrupciones, errores técnicos o accesos no autorizados ajenos a su control.</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">5. Protección de datos</h2>
          <p>El tratamiento de datos personales recabados a través del Sitio se rige por la <Link to="/privacidad" className="text-gold hover:text-white transition-colors">Política de Privacidad</Link>.</p>
        </section>

        <section>
          <h2 className="text-white font-medium mb-3">6. Legislación aplicable</h2>
          <p>Este Aviso Legal se rige por la legislación española. Para cualquier controversia derivada del acceso o uso del Sitio, las partes se someten a los Juzgados y Tribunales de Madrid, con renuncia expresa a cualquier otro fuero.</p>
        </section>

        <p className="text-white/40 text-xs pt-4">Última actualización: mayo 2026</p>
      </div>
    </div>
  </div>
);
